import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors as purchaseOrderSelectors, operations as purchaseOrderOperation } from "redux/PurchaseOrder";
import { setOrderDetail, setPurchaseorderStepperData } from "redux/PurchaseOrder/action";
import { selectors as userProfileSelectors } from "redux/UserProfile";
import PurchaseOrder from "./PurchaseOrder";
import { useParams } from "react-router-dom";
import { getFleetItemDetails, getFleetItemHeaderDetail, getFleetItemPurchaseDetails, getOrderHeaderDetail, saveMultipleDealerVendorDetails, saveMultiplePODetails, saveMultiplePurchaseOrder, setAssignedToForAllItem, setFleetItemDetails, setFleetItemHeaderDetail, setIsMultipleDealerVendorSaved, setIsMultiplePurchaseOrderSaved, setOpenAccordionList, setOrderHeaderDetail, setVinValidationResult } from "Store/Component/FleetManagement/FleetManagementAction";
import { formatPrice } from "utils";
import permissions, { isAuthorized } from "client/utils/Permissions";
import ConfirmationBee from "../../../assets/images/ConfirmationBee.svg"
import CommentBee from '../../../assets/images/PenndingApproval/Comment Bee.png'
import { getFleetItemCancel } from "Store/FleetManagement/FleetItemCancel/FleetItemCancelAction";
import { CONSTANTS } from "client/utils/constants";
import { getCatalogSpecificationBySubType } from "Store/AssetManagement/CatalogItem/CatalogItemAction";
import { setSaveAdminTaskvalue, setSavedStatus } from 'Store/FleetManagement/FleetAdminTask/AdminTaskAction';
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import {  setValidateAndSavePOSuccess } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction"
import { getVendorDetails } from "Store/Organization/VendorDetails/VendorDetailsAction";
import { setFleetItemId } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { setFleetVendorEmailHistory } from "Store/FleetManagement/FleetPOVendorEmailHistory/FleetPOVendorEmailHistoryAction";
import { getFleetItemReturnToRequestor } from "Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorAction";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

const PurchaseOrderContainer = (props: any) => {

  const { tabSwitchClicked, setTabSwitchClicked, setSelectedKey, isBulkOrder=false, tab } = props

  const [cancelComment, setCancelComment] = useState<string>('');
  const [cancelledItemFleetId, setCancelledItemFleetId] = useState<any>();
  const [accordionResetKey, setAccordionResetKey] = useState<number>(0);
  const [accordionPreExpanded, setAccordionPreExpanded] = useState<string[]>([""]);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comment: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { }
  });
  const dispatch = useDispatch();
  const dispatchChangeLogs = purchaseOrderOperation.dispatchChangeLogs(dispatch);
  const dispatchStepperData =
    purchaseOrderOperation.dispatchSetPurchaseorderStepperInfo(dispatch);
  const dispatchSetVendorDetails =
    purchaseOrderOperation.dispatchSetVendorDetails(dispatch);
  const lastDirtyPurchaseDetails = useRef<any[]>([]);

  const {
    orderDetails,
    userDetails,
    savedStatus,
    SavedAdminTaskValue,
    purchaseOrderStepperDataArr,
    validateAndSaveMultiplePoSuccess,
    orderHeaderDetails,
    fleetItemHeaderDetails,
    isMultiDealerSaved,
    isMultiPurchaseOrdersaved,
    fleetItemReturn,
    assignedForAllItem,
    openAccordionList
  }: any = useSelector((state: any) => ({
    orderDetails: purchaseOrderSelectors.getOrderDetail(state),
    userDetails: userProfileSelectors.getUserDetails(state),
    savedStatus: state.adminTaskReducer.savedStatus,
    SavedAdminTaskValue: state.adminTaskReducer.SavedAdminTaskValue,
    purchaseOrderStepperDataArr: purchaseOrderSelectors.getPurchaseOrderStepperData(state),
    validateAndSaveMultiplePoSuccess: state?.FleetProcessingReducer.validateAndSaveMultiplePoSuccess,
    orderHeaderDetails: state.fleetAdminTaskReducer?.orderHeaderDetails,
    fleetItemHeaderDetails: state.fleetAdminTaskReducer?.fleetItemHeaderDetails,
    isMultiDealerSaved: state.fleetAdminTaskReducer?.isMultiDealerSaved,
    isMultiPurchaseOrdersaved: state.fleetAdminTaskReducer?.isMultiPurchaseOrdersaved,
    fleetItemReturn : state.FleetItemReturnReducer.fleetItemReturn,
    assignedForAllItem: state.fleetAdminTaskReducer?.assignedForAllItem,
    openAccordionList: state.fleetAdminTaskReducer.openAccordionList
  }));

  const getDefaultValuesForPO = (item: any) => ({
    purchaseType: "Purchase",
    registered: false,
    orderTypeId: "1",
    reasonCodeId: "1",
    assetSourcing: "Stock",
    pricePerUnit: Number(item.price || 0).toFixed(2),
    make: item.make,
    model: item.model,
    poDescription1: item.description,
    orderId: orderDetails?.orderRequestId,
    itemNumber: String(item.itemId).split("-")[1],
    requestId: item.requestId,
    savedBy: userDetails?.emailId,
    subType: orderDetails.subOrderType,
    subTypeId: orderDetails.subOrderTypeId,
  });

  let { id } = useParams();

  useEffect(() => {
    if (id != undefined && isAuthorized(permissions.ViewPurchaseOrders)) {
      dispatch(getOrderHeaderDetail(id))
    }
  }, [id, userDetails?.permissions])

  useEffect(()=>{
    if(orderHeaderDetails?.orderRequestId == id){
      dispatch(setSavedStatus([])) 
      dispatch(setOrderDetail(orderHeaderDetails))
      dispatch(getFleetItemHeaderDetail(id))
      dispatch(getVendorDetails(''))
      dispatch(setAssignedToForAllItem([]))
      dispatch(setOpenAccordionList([]))
    }
  }, [orderHeaderDetails])


  useEffect(() => {
    if(purchaseOrderStepperDataArr?.length == 0){
    if (fleetItemHeaderDetails?.length) {
      const arr = [
        ...fleetItemHeaderDetails.map((item: any) => {
          if (item) {
            return {
              ...item,
              pricePerUnit: formatPrice(item?.pricePerUnit, 2),
              descriptionId: {label: item.description, value: item.description, key: item.description},
              savedBy: userDetails?.emailId,
              assignedTo: item?.lockedBy,
              poVendorDetails: item.poVendorDetails
                ? { ...item.poVendorDetails }
                : undefined,
              pocipDetails: item.pocipDetails
                ? { ...item.pocipDetails }
                : undefined,
              poAttachments: undefined,
              attachments: item?.poAttachments ? [...item.poAttachments] : [],
              isPurchaseDetailsSave: true,
              isPurchaseOrderSave: true,
              isDealerVendorSave: true,
              assetAfterSave: item?.assetNumber,
            };
          }
          return getDefaultValuesForPO(item);
        }),
      ];
      dispatchStepperData(arr);
    }else{
      dispatchStepperData([]);
    }
    }
  }, [fleetItemHeaderDetails]);

  useEffect(() => {
    return () => {
    dispatch(setSavedStatus([]))
    dispatch(setOrderHeaderDetail({}))
    dispatch(setFleetItemDetails({}))
    dispatchSetVendorDetails({});
    dispatchStepperData([]);
    dispatch(setFleetItemId(null))
    dispatch(setFleetItemHeaderDetail({}))
    dispatch(setPurchaseorderStepperData([]))
    dispatch(setFleetVendorEmailHistory([]))
    }
  }, []);

  useEffect(() => {
    document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    dispatch(setSaveAdminTaskvalue({}))
  }, []);


  const showEditBtn = (status?: any, fleetId?: any) => {
    let val = savedStatus?.filter((savedItem?: any) => savedItem?.fleetItemId == fleetId)
    let savedVal: any
    if(val?.length){
      savedVal = val[0]
    }
    if (isAuthorized(permissions.DeletePurchaseOrder) && status != CONSTANTS?.ORDER_STATUS?.REQUISITION_COMPLETE && status != CONSTANTS.ORDER_STATUS.CANCELLED && savedVal?.fleetStatus != CONSTANTS?.ORDER_STATUS?.REQUISITION_COMPLETE) {
      return true
    } else {
      return false
    }
  }

  const handleItemCancelClick = (e?: any, id?: any) => {
    e.preventDefault();
    e.stopPropagation()
    let decriptionTxt = (
      <>
        <p>Are you sure you want to cancel this item?</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "Confirmation",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        setCancelledItemFleetId(0)
        setCancelComment('')
      },
      popupPrimarybtnOnclick: (item: any,
        comment: string,
        actionby: string,
        value: any) => {
        let val = {
          fleetDetailId: parseInt(id),
          savedBy: userDetails?.emailId,
          comments: comment
        }
        setCancelledItemFleetId(id);
        dispatch(getFleetItemCancel(val))
        setCancelComment(comment)
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }
    });
  }

  const hideConfirmationDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  useEffect(()=>{
    if(!validateAndSaveMultiplePoSuccess?.assetValidateResponses && (validateAndSaveMultiplePoSuccess?.isSucessfullySaved || isMultiDealerSaved || isMultiPurchaseOrdersaved?.isSaved) && tabSwitchClicked){
      setTabSwitchClicked(false);
      setSelectedKey(tab)
    } else if(validateAndSaveMultiplePoSuccess?.assetValidateResponses?.length > 0 && tabSwitchClicked){
      let inValidAsset = validateAndSaveMultiplePoSuccess?.assetValidateResponses?.filter((i: any) => !i?.isValid)?.map((i:any) => i?.assetNumber)
      let purchaseOrderStepperDataArrTemp = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))?.map((fleetItem: any) => {
        if(inValidAsset?.includes(Number(fleetItem.assetNumber))){
           return {...fleetItem, 
              assetIsValid: validateAndSaveMultiplePoSuccess?.assetValidateResponses?.find((i:any)=> i?.assetNumber == fleetItem?.assetNumber)?.isValid, 
              validationMessage: validateAndSaveMultiplePoSuccess?.assetValidateResponses?.find((i:any)=> i?.assetNumber == fleetItem?.assetNumber)?.validationMessage
            }
        }
        return fleetItem
      })

      dispatchStepperData(purchaseOrderStepperDataArrTemp)

      let decriptionTxt = (
        <>
          <p>Please enter the valid asset in items {inValidAsset?.map((i:any) => <span>{i} </span> )} before saving.</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick:  () => {hideConfirmationDialog(); setTabSwitchClicked(false);}
      });
    } else if (validateAndSaveMultiplePoSuccess?.vinDuplicateItems?.length > 0 && tabSwitchClicked) {
      // VIN duplicate — capture items before clearing Redux state
      const vinDuplicateItems = validateAndSaveMultiplePoSuccess.vinDuplicateItems;
      const duplicateItemNumbers = vinDuplicateItems
        .map((vin: any) => {
          const stepperItem = purchaseOrderStepperDataArr?.find(
            (s: any) => s.fleetRequestDetailId === vin.fleetRequestDetailId
          );
          return stepperItem ? `Item ${stepperItem?.itemNumber} (${stepperItem?.vinSerial})` : vin.fleetRequestDetailId;
        })
        .join(', ');
      // Clear Redux state immediately so tab switches don't re-trigger this popup
      dispatch(setValidateAndSavePOSuccess({}));
      showVinDuplicatePopup(
        `This is a duplicate VIN/Serial Number, duplicates are allowed but please confirm entry. Duplicate items: ${duplicateItemNumbers}`,
        () => {
          // OK — re-dispatch all dirty purchase details with forceVinSave: true
          const forcedDetails = lastDirtyPurchaseDetails.current.map((item: any) => ({
            ...item,
            forceVinSave: true
          }));
          dispatch(saveMultiplePODetails(forcedDetails));
        }
      );
    }
  }, [validateAndSaveMultiplePoSuccess, isMultiDealerSaved, isMultiPurchaseOrdersaved])

  // Validate critical fields before saving
  const validateNullFields = (payload: any) => {
    const notNullFields = [
      { key: 'assetSourcing', value: payload.assetSourcing },
      { key: 'orderTypeId', value: payload.orderTypeId },
      { key: 'isLicensedTitled', value: payload.isLicensedTitled},
      { key: 'purchaseType', value: payload.purchaseType }
    ];
    
    const hasNullFields = notNullFields.some(field => 
      field.value === null || field.value === undefined || field.value === ''
    );
    
    return !hasNullFields;
  };

  // Show validation warning popup
  const showValidationWarning = () => {
    let decriptionTxt = (
      <>
            <p>Some details were not loaded properly.  Please select ‘OK’ to refresh and then select Save again.</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "OK",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false });
        setTabSwitchClicked(false);
        if (id) {
          dispatch(getOrderHeaderDetail(id));
          dispatch(getFleetItemHeaderDetail(id));
          // Refresh individual item details for each fleet item
          purchaseOrderStepperDataArr?.forEach((item: any) => {
            if (item?.fleetRequestDetailId) {
              dispatch(getFleetItemDetails(item.fleetRequestDetailId));
              dispatch(getFleetItemPurchaseDetails(item.fleetRequestDetailId));
            }
          });
        }
      }
    });
  };

  const showDuplicatePopup = (message: any) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: message,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclick: () => { hideConfirmationDialog(); setTabSwitchClicked(false); }
    });
  };

  // Shared helper — shows the VIN duplicate confirmation popup.
  // onConfirm is called when user clicks OK to proceed with save.
  const showVinDuplicatePopup = (message: string, onConfirm: () => void) => {
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: '',
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: <p>{message}</p>,
      primaryBtnText: 'OK',
      outlineBtnText: 'Cancel',
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => { hideConfirmationDialog(); setTabSwitchClicked(false); },
      popupPrimarybtnOnclick: () => {
        hideConfirmationDialog();
        onConfirm();
      },
    });
  };

  const saveChangesOnClick = () => {
    const { dirtyPurchaseDetails, dirtyVendorDetails, dirtyPurchaseOrders } = dirtyFleetItems;

    // Step 1: Validate critical fields before saving purchase details
    if (dirtyPurchaseDetails?.length) {
      const hasInvalidFields = dirtyPurchaseDetails.some((item: any) => !validateNullFields(item));
      if (hasInvalidFields) {
        showValidationWarning();
        return;
      }
    }

    // Step 2: Check for duplicate Asset # within the order (same as single-save handleBlurChange)
    if (dirtyPurchaseDetails?.length) {
      const duplicateAssetItems: any[] = [];
      dirtyPurchaseDetails.forEach((dirtyItem: any) => {
        if (!dirtyItem?.assetNumber) return;
        const isDuplicate = purchaseOrderStepperDataArr?.some(
          (other: any) =>
            other.fleetRequestDetailId !== dirtyItem.fleetRequestDetailId &&
            other?.assetNumber &&
            Number(other.assetNumber) === Number(dirtyItem.assetNumber)
        );
        if (isDuplicate) duplicateAssetItems.push(dirtyItem.fleetRequestDetailId);
      });

      if (duplicateAssetItems.length > 0) {
        const errMsg = "The Asset # you have entered is already associated with other item. Please enter a new asset number that is not been associated.";
        const invalidAssetNumbers: string[] = [];
        const updatedStepperArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr)).map((item: any) => {
          if (duplicateAssetItems.includes(item.fleetRequestDetailId)) {
            invalidAssetNumbers.push(item.assetNumber);
            return { ...item, assetIsValid: false, validationMessage: errMsg };
          }
          return item;
        });
        dispatchStepperData(updatedStepperArr);
        showDuplicatePopup(
          <p>Please enter the valid asset in items {invalidAssetNumbers.map((i) => <span key={i}>{i} </span>)} before saving.</p>
        );
        return;
      }
    }

    // Step 2.5: Check for duplicate VIN/Serial within the order — show confirmation popup (user can proceed)
    if (dirtyPurchaseDetails?.length) {
      const duplicateVinPairs: any[] = [];
      dirtyPurchaseDetails.forEach((dirtyItem: any) => {
        const trimmed = dirtyItem?.vinSerial?.trim()?.toLowerCase();
        if (!trimmed) return;
        const isDuplicate = purchaseOrderStepperDataArr?.some(
          (other: any) =>
            other.fleetRequestDetailId !== dirtyItem.fleetRequestDetailId &&
            other?.vinSerial?.trim()?.toLowerCase() === trimmed
        );
        if (isDuplicate) duplicateVinPairs.push(dirtyItem);
      });

      if (duplicateVinPairs.length > 0) {
        dispatch(setValidateAndSavePOSuccess({}));
        showVinDuplicatePopup(
          'The VIN/Serial you have entered is already associated with another item in this order. Do you still want to save?',
          () => {
            // Proceed with forceVinSave: true so backend skips its own within-order check
            const forcedDetails = dirtyPurchaseDetails.map((item: any) => ({
              ...item,
              forceVinSave: true
            }));
            lastDirtyPurchaseDetails.current = forcedDetails;
            dispatch(saveMultiplePODetails(forcedDetails));
            if (dirtyVendorDetails?.length) dispatch(saveMultipleDealerVendorDetails(dirtyVendorDetails));
            if (dirtyPurchaseOrders?.length) dispatch(saveMultiplePurchaseOrder(dirtyPurchaseOrders));
          }
        );
        return;
      }
    }

    // Validate critical fields for purchase details before saving
    if(dirtyPurchaseDetails?.length) {
      let hasInvalidFields = false;
      
      dirtyPurchaseDetails.forEach((item: any) => {
        if (!validateNullFields(item)) {
          hasInvalidFields = true;
        }
      });

      if (hasInvalidFields) {
        showValidationWarning();
        return;
      }
    }

    dispatch(setValidateAndSavePOSuccess({}))
    dispatch(setIsMultipleDealerVendorSaved(undefined))
    dispatch(setIsMultiplePurchaseOrderSaved(undefined))
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })

    if(dirtyPurchaseDetails?.length){
      lastDirtyPurchaseDetails.current = dirtyPurchaseDetails;
      dispatch(saveMultiplePODetails(dirtyPurchaseDetails))
    }

    if(dirtyVendorDetails?.length){
      dispatch(saveMultipleDealerVendorDetails(dirtyVendorDetails))
    }

    if(dirtyPurchaseOrders?.length) {
      dispatch(saveMultiplePurchaseOrder(dirtyPurchaseOrders))
    }

  }

  const dirtyFleetItems: any = useMemo(() => {
    if (purchaseOrderStepperDataArr?.length) {
      let dirtyPurchaseDetails: any[] = []
      let dirtyVendorDetails: any[] = []
      let dirtyPurchaseOrders: any[] = []
      
      purchaseOrderStepperDataArr?.forEach((item: any)=>{
        if(!item?.isPurchaseDetailsSave){
          const payload = {
            fleetRequestDetailId: item?.fleetRequestDetailId,
            savedBy: userDetails?.emailId,
            purchaseType: item?.purchaseType,
            pricePerUnit: item?.pricePerUnit ? parseFloat(getOnlyNumbers(item?.pricePerUnit)) : 0,
            popricePerUnit: item?.popricePerUnit,
            pocipDetails: item?.pocipDetails,
            assetNumber: item?.assetNumber || 0,
            orderTypeId: item?.orderTypeId,
            assetSourcing: item?.assetSourcing,
            poDescription1: item?.poDescription1,
            poDescription2: item?.poDescription2,
            description: item?.description,
            make: item?.make,
            model: item?.model,
            assetModelId: item?.assetModelId,
            isLicensedTitled: item?.isLicensedTitled,
            isCIPOrder: item?.isCIPOrder,
            createUniquePO: item?.createUniquePO,
            barcodeNo: item?.barcodeNo,
            year: item?.year,
            vinSerial: item?.vinSerial
          }
          dirtyPurchaseDetails?.push(payload)
        } else if(!item?.isDealerVendorSave){
          const payload = {
            fleetRequestDetailId: item?.fleetRequestDetailId,
            savedBy: userDetails?.emailId,
            poVendorDetails: {
              ...item?.poVendorDetails,
              fleetRequestVendorId: item?.poVendorDetails?.fleetRequestVendorId || 0
            },
            poDealerDetails: {
              ...item?.poDealerDetails,
              fleetRequestDealerId: item?.poDealerDetails?.fleetRequestDealerId || 0
            },
            isVendorSameAsDealer: item?.isVendorSameAsDealer
          }
          dirtyVendorDetails.push(payload)
        } else if(!item?.isPurchaseOrderSave){
          const payload = {
            fleetDetailId: item?.fleetRequestDetailId,
            ponumber: item?.poNumber,
            make: item?.make,
            model: item?.model,
            eqClassCode: item?.eqClassCode,
            eqClassDescription: item?.eqClassDescription,
            glaccountNumber: item?.glaccountNumber,
            poDescription1: item?.poDescription1,
            poDescription2: item?.poDescription2,
            poReceiptDate: item?.poReceiptDate,
            poCreationDate: item?.poCreationDate,
            barcodeNo: item?.barcodeNo,
            savedBy: userDetails?.emailId,
          }  
          dirtyPurchaseOrders.push(payload)
        }
      })
      return { dirtyPurchaseDetails,  dirtyVendorDetails, dirtyPurchaseOrders}
    }
  }, [JSON.stringify(purchaseOrderStepperDataArr), orderDetails])
 
  useEffect(()=>{
    if(tabSwitchClicked && ( dirtyFleetItems?.dirtyPurchaseDetails?.length || dirtyFleetItems?.dirtyVendorDetails?.length || dirtyFleetItems?.dirtyPurchaseOrders?.length)){
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "UNSAVED CHANGES",
        isDialogVisible: true,
        subtextcontent: 'You have unsaved changes:   You can leave to discard your changes, or close to continue editing.',
        primaryBtnText: "Save",
        outlineBtnText: "Cancel",
        isSingleConfirmationBtn: false,
        popupOutlinebtnOnclick:  () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
          setTabSwitchClicked(false);
          setSelectedKey(tab)
        },
        popupPrimarybtnOnclick: ()=>{
          saveChangesOnClick()
        }
      });
    } else if(tabSwitchClicked) {
      setSelectedKey(tab)
    }
  }, [tabSwitchClicked])

  useEffect(()=>{
    if(assignedForAllItem?.response){
      const fleetIds = assignedForAllItem?.payload?.fleetItemIds
      const filteredArray = fleetIds?.filter((value:any) => openAccordionList?.includes(value));
      filteredArray?.map((item:any)=>{
        dispatchChangeLogs(item)
      })
    }
  },[assignedForAllItem])

  const onChangeAccordion = (ExpandedItemsDetail: any, item:any) => {
    const fleetItem = ExpandedItemsDetail?.find((i: any) => i?.uuid === item.at(-1))
    const latestHeaderItem = fleetItemHeaderDetails?.find((h: any) => Number(h?.fleetRequestDetailId) === Number(fleetItem?.fleetRequestId));
    const filterArray = ExpandedItemsDetail?.filter((i:any)=>item.includes(i.uuid)).map((i:any)=>{return i.fleetRequestId})
    dispatch(setOpenAccordionList(filterArray))
    // Keep local preExpanded in sync so remount preserves currently-open items
    setAccordionPreExpanded(item)
    if(fleetItem?.fleetRequestId){
      dispatch(getFleetItemDetails(fleetItem?.fleetRequestId))
      dispatchChangeLogs(fleetItem?.fleetRequestId)
      dispatch(getCatalogSpecificationBySubType(latestHeaderItem?.requestDetailId, fleetItem?.fleetRequestId, isBulkOrder));
      dispatch(setVinValidationResult(null));
    }
  }

  /**
   * Called by PurchaseDetail after a successful catalog override save.
   * Collapses the saved item's accordion and refreshes fleet item headers.
   */
  const handleCatalogOverrideSaved = (fleetId: number) => {
    const remainingOpenIds = openAccordionList?.filter((id: number) => id !== fleetId) ?? [];
    // Map remaining open fleet IDs back to accordion uuids via stepper data index
    const newPreExpanded = remainingOpenIds
      .map((id: number) => {
        const idx = purchaseOrderStepperDataArr?.findIndex((item: any) => item.fleetRequestDetailId === id);
        return idx >= 0 ? `Accordion${idx}` : null;
      })
      .filter(Boolean) as string[];
    dispatch(setOpenAccordionList(remainingOpenIds));
    setAccordionPreExpanded(newPreExpanded);
    setAccordionResetKey((prev) => prev + 1);
    // Refresh all item headers so reopened accordion shows updated catalog data
    dispatch(getFleetItemHeaderDetail(id));
  };

  const handleorderLevelReturn = (e?: any, request?: any) => {
    e.preventDefault();
    e.stopPropagation();
    let decriptionTxt = (
      <>
        <p>Please provide a comment before returning order request to the requestor</p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: CommentBee,
      title: "RETURN ENTIRE ORDER TO REQUESTOR",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      primaryBtnText: "Return",
      outlineBtnText: "Cancel",
      isCommentboxVisible: true,
      isCommentBoxRequire: true,
      isSingleConfirmationBtn: false,
      popupOutlinebtnOnclick: () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      },
      popupPrimarybtnOnclick: (item: any,
        comment: string,
        actionby: string,
        value: any) => {
          let consolidatedItemId: any = []
          let fleetItemId:any = 0
          let isCipPoolVal: any = {};
            const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(request));
            saveConsolidatedPoDataArr?.map((item: any) => {
              isCipPoolVal = fleetItemHeaderDetails?.find((headerItem?: any) => headerItem?.fleetRequestDetailId == item?.fleetRequestDetailId)
              if (item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && (item?.poNumber == null || item?.poNumber == undefined || item?.poNumber == 0) && !isCipPoolVal?.isCipPool) {
                if(fleetItemId == 0){
                  fleetItemId = item?.fleetRequestDetailId
                }else{
                  consolidatedItemId.push(item?.fleetRequestDetailId)
                }
              }
            })

        let val = {
          orderId : request?.[0]?.orderRequestId,
          fleetDetailId: parseInt(fleetItemId),
          savedBy: userDetails?.emailId,
          comments: comment,
          consolidatedFleetIds : consolidatedItemId
        }
        dispatch(getFleetItemReturnToRequestor(val));
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
      }
    });
  }

  const getShowOrderReturn = useCallback((request?: any) => {
    let count = 0;
    let val: any = {};
    let isAllValidItem = request?.filter((item?: any) => !item?.alreadyReturnedFromFleet)?.length
    if (isAllValidItem == fleetItemHeaderDetails?.length && isAuthorized(FLEET_PROCESSING_PERMISSIONS.RETURN_TO_REQUESTOR)) {
      request?.map((item?: any) => {
        val = fleetItemHeaderDetails?.find((headerItem?: any) => headerItem?.fleetRequestDetailId == item?.fleetRequestDetailId)
        if (item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && item?.itemStatus !== CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && (item?.poNumber == null || item?.poNumber == undefined || item?.poNumber == 0) && !val?.isCipPool) {
          count++
        }
      })
    }
    if (count > 1) {
      return true
    } else {
      return false
    }
  },[fleetItemReturn, fleetItemHeaderDetails])

  return (
    <PurchaseOrder
      orderDetails={orderDetails}
      onChangeAccordion={onChangeAccordion}
      dispatchStepperData={dispatchStepperData}
      savedStatus = {savedStatus}
      showEditBtn = {showEditBtn}
      handleItemCancelClick = {handleItemCancelClick}
      Popupcontent = {Popupcontent}
      hideConfirmationDialog = {hideConfirmationDialog}
      SavedAdminTaskValue={SavedAdminTaskValue}
      setCancelledItemFleetId = {setCancelledItemFleetId}
      cancelledItemFleetId={cancelledItemFleetId}
      isBulkOrder={isBulkOrder}
      purchaseOrderStepperDataArr={purchaseOrderStepperDataArr}
      key={id}
      setCancelComment = {setCancelComment}
      cancelComment = {cancelComment}
      handleorderLevelReturn = {handleorderLevelReturn}
      getShowOrderReturn = {getShowOrderReturn}
      onCatalogOverrideSaved={handleCatalogOverrideSaved}
      accordionResetKey={accordionResetKey}
      accordionPreExpanded={accordionPreExpanded}
    />
  );
};

export default PurchaseOrderContainer;
